import { enums } from '@bluecrew/bluecrew-lib'

class StatusChangeController {
  /* @ngInject */
  constructor (reasonOptions, newStatus, $mdDialog) {
    this.newStatus = newStatus
    this.otherReasonId = 19
    this.timeTheftId = 23
    this.reason = null
    this.note = null
    this.$mdDialog = $mdDialog
    this.enums = enums
    this.actionName = ''
    
    switch (newStatus) {
      case enums.PayrollHoursStatus.APPROVED:
        this.actionName = 'APPROVE'
        break
      case enums.PayrollHoursStatus.REJECTED:
        this.actionName = 'REJECT'
        break
      case enums.PayrollHoursStatus.EXCUSED:
        this.actionName = 'EXCUSE'
        break
    }

    this.reasonOptions = reasonOptions
  }

  submit () {
    this.$mdDialog.hide({
      reason: this.reason, note: this.note
    })
  }

  cancel () {
    this.$mdDialog.cancel()
  }
}

export default StatusChangeController
